import { render, staticRenderFns } from "./WhoIsOwner.vue?vue&type=template&id=15203e21&scoped=true&"
import script from "./WhoIsOwner.vue?vue&type=script&lang=js&"
export * from "./WhoIsOwner.vue?vue&type=script&lang=js&"
import style0 from "./WhoIsOwner.vue?vue&type=style&index=0&id=15203e21&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15203e21",
  null
  
)

export default component.exports